// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2p5i_","author":"Table_author__2GuBL","authorImage":"Table_authorImage__1ZoMQ","unreadRow":"Table_unreadRow__AAa9o"};